import { AssetDto } from '@pages/assets-page/components/interfaces';
import { OnCallDto } from '@pages/on-call-page/interfaces';
import { POIDto } from '@pages/poi-page/interfaces';
import { VehicleDto } from '@pages/vehicles-page/components/vehicles-grid/interfaces';
import { RegistryComponentNames } from '@shared/constants/registry-component-name';

export default class MarkerPopupUtils {
  static getVehiclePopupElementFromRegistry(
    vehicle: Partial<VehicleDto>,
    carUrl: string,
    showGoogleMapsLink = false,
    showGeofence = false,
    hasTempGeofence = false,
    entityId?: string,
    geofenceId?: string
  ): string {
    const mapsUrl =
      showGoogleMapsLink && vehicle.LastGPSLat && vehicle.LastGPSLon
        ? `https://maps.google.com/?q=loc:${vehicle.LastGPSLat},${vehicle.LastGPSLon}`
        : '';
    const popupEl = `<${RegistryComponentNames.DriverPopupContent}
        car-icon-url="${carUrl}"
        vehicle-description="${vehicle.VehicleDescription || '-'}"
        user-description="${vehicle.UserDescription || '-'}"
        user-name="${vehicle.Username || '-'}"
        user-mobile="${vehicle.UserMobile || ''}"
        last-activity-time="${vehicle.LastActivityTime || ''}"
        has-temporary-geofence="${hasTempGeofence}"
        show-geofence="${showGeofence}"
        id="${vehicle.TrackerObjectID || ''}"
        entity-id="${entityId || ''}"
        geofence-id="${geofenceId || ''}"
        lat="${vehicle.LastGPSLat ?? ''}"
        lng="${vehicle.LastGPSLon ?? ''}"
        user-status-key="${vehicle.UserStatusTranslationKey || ''}"
        maps-url="${mapsUrl}"></${RegistryComponentNames.DriverPopupContent}>`;

    return popupEl;
  }

  static getAssetPopupElementFromRegistry(
    asset: Partial<AssetDto>,
    hasTempGeofence = false,
    entityId?: string
  ): string {
    const popupEl = `<${RegistryComponentNames.AssetPopupContent}
    description="${asset.Description || '-'}"
    user-name="${asset.Username || '-'}"
    department="${asset.Department || '-'}"
    current-location="${asset.CurrentLocation || '-'}"
    serial="${asset.Serial || '-'}"
    last-activity-time="${asset.LastActivityTime || ''}"
    document-thumbnail="${asset.DocumentThumbnail || ''}"
    temperature="${asset.Temperature ?? ''}"
    last-moved="${asset.LastMoved || '-'}"
    has-temporary-geofence="${hasTempGeofence}"
    id="${asset.AssetID || ''}"
    entity-id="${entityId || ''}"
    lat="${asset.LastGPSLat ?? ''}"
    lng="${asset.LastGPSLon ?? ''}"
    document-id="${asset.ImageDocumentID ?? ''}"
    ></${RegistryComponentNames.AssetPopupContent}>`;

    return popupEl;
  }

  static getLocationPopupElementFromRegistry(location: OnCallDto): string {
    const popupEl = `<${RegistryComponentNames.LocationPopupContent}
    user-name="${location.UserDescription || location.Username || '-'}"
    location="${location.Description || '-'}"
    on-call-status="${location.OnCallStatus || '-'}"
    mobile="${location.Mobile || '-'}"
    properties="${location.UserTag || '-'}"
    department="${location.DepartmentDescription || '-'}"
    call-out-count="${location.CallOuts || 0}"
    user-id="${location.UserID}"
    on-call-site-id="${String(location.OnCallSiteID)}"
    last-call-out-time="${location.LastCallOutTime || ''}"
    on-call-id="${location.ID}"
    can-be-called-out="${location.CanBeCalledOut}"
    ></${RegistryComponentNames.LocationPopupContent}>`;

    return popupEl;
  }

  static getPoiPopupElementFromRegistry(poi: Partial<POIDto>): string {
    const popupEl = `<${RegistryComponentNames.POiPopupContent}
    icon-key="${poi.IconKey || ''}"
    icon-color="${poi.IconColor || ''}"
    description="${poi.Description || ''}"
    purpose="${poi.Purpose || ''}"
    poi-type-key="${poi.POIType_TranslationKey || ''}"
    severity-key="${poi.Severity_TranslationKey || ''}"
    ></${RegistryComponentNames.POiPopupContent || ''}>`;

    return popupEl;
  }
}
